import { css, DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components';

const primary = css`
	background-color: ${(props) => props.theme.colors.primary.primary50_key};
	color: ${(props) => props.theme.colors.gray.gray_white};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.gray.gray_white};
	}
`;

const secondary = css`
	background-color: ${(props) => props.theme.colors.primary.primary10_lighten};
	color: ${(props) => props.theme.colors.primary.primary80_darken};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.primary.primary80_darken};
	}
`;

const black = css`
	background-color: ${(props) => props.theme.colors.gray.gray80_text};
	color: ${(props) => props.theme.colors.gray.gray_white};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.gray.gray_white};
	}
`;

const gray = css`
	background-color: ${(props) => props.theme.colors.gray.gray15};
	color: ${(props) => props.theme.colors.gray.gray80_text};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.gray.gray80_text};
	}
`;

const red = css`
	background-color: ${(props) => props.theme.colors.system.red_lighten};
	color: ${(props) => props.theme.colors.system.red_darken};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.system.red_darken};
	}
`;

const yellow = css`
	background-color: ${(props) => props.theme.colors.system.yellow_lighten};
	color: ${(props) => props.theme.colors.system.yellow_darken};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.system.yellow_darken};
	}
`;

const green = css`
	background-color: ${(props) => props.theme.colors.system.green_lighten};
	color: ${(props) => props.theme.colors.system.green_darken};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.system.green_darken};
	}
`;

const blue = css`
	background-color: ${(props) => props.theme.colors.system.blue_lighten};
	color: ${(props) => props.theme.colors.system.blue_darken};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.system.blue_darken};
	}
`;

interface ITagColorType {
	primary: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	secondary: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	black: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	gray: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	red: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	yellow: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	green: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	blue: FlattenInterpolation<ThemeProps<DefaultTheme>>;
}

export const tagColorType: ITagColorType = {
	primary,
	secondary,
	black,
	gray,
	red,
	yellow,
	green,
	blue,
};
